import { LocalizedText, lt, showSuccessAlert } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Banner, Button, Grid, IconName, Stack } from '@optimus-web/core';
import { copyToClipboard } from '@mews-commander/utils';
import { CodeElement } from './CodeElement';

export interface Configure2FADeviceRecoveryPinsProps {
    recoveryPins: string[];
}

export function Configure2FADeviceRecoveryPins({ recoveryPins }: Configure2FADeviceRecoveryPinsProps) {
    const copyRecoverPins = () => {
        copyToClipboard(recoveryPins.join(', '));
        showSuccessAlert({ description: lt('CopyToClipboard') });
    };

    return (
        <Stack spacing="200" vertical>
            <Banner
                variant="warning"
                primaryText={<LocalizedText textKey={TextKey.TwoFactorAuthenticationAppRecoveryPinBannerTitle} />}
                secondaryText={
                    <LocalizedText textKey={TextKey.TwoFactorAuthenticationAppRecoveryPinBannerDescription} />
                }
            />
            <Grid templateColumns="repeat(2, 1fr)" gap="100">
                {recoveryPins.map((code: string) => (
                    <CodeElement key={code}>{code}</CodeElement>
                ))}
            </Grid>
            <Stack>
                <Button icon={IconName.Copy} variant="ghost" onClick={copyRecoverPins} type="submit">
                    <LocalizedText textKey={TextKey.CopyToClipboard} />
                </Button>
            </Stack>
        </Stack>
    );
}
